import { type ComponentProps } from 'react';
import { Link } from 'react-router-dom';
import { useSesion } from '../servicios/sesion.js';
import { permisoDeRuta } from '../servicios/rutas.js';

/**
 * Enlace que solo se muestra si el usuario puede abrir su destino. Así no se
 * ofrece un enlace que llevaría a una pantalla sin acceso.
 */
export function EnlaceRuta({ to, ...resto }: ComponentProps<typeof Link> & { to: string }): JSX.Element | null {
  const { puede } = useSesion();
  const permiso = permisoDeRuta(to);
  if (permiso && !puede(permiso)) return null;
  return <Link to={to} {...resto} />;
}
